/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {GiftStatus} from 'hiya-common/src/constant/goodSale'
import {http} from 'hiya-common/src/utils/axios'

export enum ActStatus {
  processing = 0,
  notStarted = 0,
}

// 商店售卖活动列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92462432
export const getShopSaleList = createAsyncThunk(
  'GoodsSale/getMission',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/shop_sale_list', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 商店售卖活动购买
export const shopSaleBuy = createAsyncThunk(
  'GoodsSale/getReward',
  async (p: {id: number; buy_cnt: number; to_mid?: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        status?: GiftStatus
      }>
    >('/live/activity/shop_sale_buy', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

interface IInfo {
  id: number
  goods_name: string
  goods_price: number
  goods_pic: string
  platform_limit: number
  platform_remain_cnt: number
}
export interface RecordInfo {
  mid: number
  goods_name: string
  name: string
  avatar: string
}
const initialState: {
  shop_sale_list?: Array<IInfo>
  count_down?: number
  status?: ActStatus
  start_time?: string
  end_time?: string
  record_list?: Array<RecordInfo>
  desc?: string
} = {}

export const GoodsSaleSlice = createSlice({
  name: 'GoodsSale',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getShopSaleList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})

export default GoodsSaleSlice.reducer
